/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Add_LanguageInputs */



/**
* | output |
* | --- |
* | "Add language" |
*
* @param {Profile_Add_LanguageInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_add_language = /** @type {((inputs?: Profile_Add_LanguageInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Add_LanguageInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter une langue")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir idioma")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Adicionar idioma")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi lingua")
	return /** @type {LocalizedString} */ ("Add language")
});